<template>
    <div class="info">
        <div class="my__blood-top">
            <div class="blood-calendar">
                <div class="blood-calendar__top">
                    <a href="javascript:;" class="blood-calendar--today" @click="todayCalendar">오늘</a>
                    <a href="javascript:;" class="blood-calendar--button prev" @click="prevCalendar"></a>
                    <h4 class="title02">{{calYear}}-{{calMonth}}</h4>
                    <a href="javascript:;" class="blood-calendar--button next" @click="nextCalendar"></a>
                </div>
                <table class="blood-calendar__body">
                    <caption> 예약일 선택 테이블 </caption>
                    <colgroup>
                        <col width="14.29%">
                        <col width="14.29%">
                        <col width="14.29%">
                        <col width="14.29%">
                        <col width="14.29%">
                        <col width="14.29%">
                        <col width="14.29%">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>일</th>
                            <th>월</th>
                            <th>화</th>
                            <th>수</th>
                            <th>목</th>
                            <th>금</th>
                            <th>토</th>
                        </tr>
                    </thead>
                    <tbody v-if="calendarList">
                        <!-- td classList - none: 지난달, 다음달 / on:  측정기록이 있는날 / active -->
                        <tr v-for="item in arrChunk(calendarList)" :key="item">
                            <td v-for="i in item" :key="i" :class="[i.dayType, {'active' : i.text == activeIndex}, {'on' : hasNoteDay(i.text)}]" >
                                <a href="javascript:;" @click="[selectDate(i.year, i.month, i.day), activeIndex = i.text]">
                                    {{i.day}}
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="blood-calendar__bottom">
                    <p>
                        <span class="c-red">*</span> 조회 및 등록을 원하시는 날짜를 선택해주세요.
                    </p>
                    <div class="blood-calendar__state">
                        <div class="blood-calendar__state__item">
                            <span></span>
                            기록
                        </div>
                        <div class="blood-calendar__state__item">
                            <span></span>
                            오늘
                        </div>
                    </div>
                </div>
            </div>
            <div class="headbook">
                <div class="headbook__top">
                    <h3 class="title02">{{$commonUtils.makeDateFormat(selectDay, '-')}}</h3>
                    <router-link :to="`/kr/mypage/headNote/headNoteWrite?painDate=${selectDay}`" class="main-button small c-main" >기록하기</router-link>
                </div>
                <ul class="headbook__list">
                    <template v-for="item in currentNoteList" :key="i">
                        <li v-if="item.painDate === selectDay">
                            <a href="javascript:;" @click="selectNote(item)" :class="{active:item === selectedNote}">
                                <span class="headbook--time">{{ item.painStartTime.slice(0,2) + ':' + item.painStartTime.slice(2) }} ~ {{ item.painEndTime.slice(0,2) + ':' + item.painEndTime.slice(2) }} </span>
                                <span class="headbook--text">두통기록</span>
                            </a>
                        </li>
                    </template>
                </ul>
            </div>
        </div>
    </div>
    <div class="info" v-if="$commonUtils.isNotEmpty(selectedNote) ">
        <div class="table-wrap">
            <div class="table headtable">
                <table>
                    <colgroup>
                        <col style="width:25%;">
                        <col style="width:75%;">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>
                                <h4 class="title02">{{$commonUtils.makeDateFormat(selectDay, '-')}}</h4>
                            </th>
                            <th class="">
                                <div class="headtable__header">
                                    <ul class="headtable__time">
                                        <li>{{ selectedNote.painStartTime.slice(0,2) + ':' + selectedNote.painStartTime.slice(2) }} <span>시작</span></li>
                                        <li>{{ selectedNote.painEndTime.slice(0,2) + ':' + selectedNote.painEndTime.slice(2) }} <span>종료</span></li>
                                    </ul>
                                    <div class="botton-wrap">
                                        <a href="javascript:;" class="main-button small c-gray" @click="deleteNote">삭제</a>
                                        <a href="javascript:;" class="main-button small c-main" @click="modifyNote">수정</a>
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th><h4 class="title03">통증 부위</h4></th>
                            <td>
                                <ul class="headtable__area">
                                    <li class="headtable__area--front">
                                        <p class="left">우측</p>
                                        <p class="right">좌측</p>
                                        <div class="headtable__area--img">
                                            <img src="@/assets/resource/img/headtable__area--front.png" alt="">
                                            <template v-for="option in areaOptions.slice(0,10)" :key="option">
                                                <label for="" class="headtable__area--check" :class="getCheckClass(option)">
                                                    <input type="checkbox" v-model="selectedNote.painAreaTemp" :value="option" disabled>
                                                    <span></span>
                                                </label>
                                            </template>
                                        </div>
                                    </li>
                                    <li class="headtable__area--back">
                                        <p class="left">좌측</p>
                                        <p class="right">우측</p>
                                        <div class="headtable__area--img">
                                            <img src="@/assets/resource/img/headtable__area--back.png" alt="">
                                            <template v-for="option in areaOptions.slice(10,18)" :key="option">
                                                <label for="" class="headtable__area--check" :class="getCheckClass(option)">
                                                    <input type="checkbox" v-model="selectedNote.painAreaTemp" :value="option" disabled>
                                                    <span></span>
                                                </label>
                                            </template>
                                        </div>
                                    </li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <th><h4 class="title03">통증 강도</h4></th>
                            <td>
                                <p class="headtable__strength">
                                    <strong>{{ selectedNote.painLevel }}</strong> / 10
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <th><h4 class="title03">통증 유형</h4></th>
                            <td>
                                <ul class="head-symptom__list">
                                    <template v-for="option in painType" :key="option">
                                        <li v-if="selectedNote.painType === option.value">
                                            <a href="javascript:;" >
                                                <div class="icon" :class="`head-${option.value === 'etc' ? 'etc' : 'type' + option.value}`"></div>
                                                <p>{{ option.label }}</p>
                                            </a>
                                        </li>
                                    </template>
                                </ul>
                                <input v-if="selectedNote.painType === 'etc'" type="text" class="head-symptom__input" :value="selectedNote.painTypeEtc" disabled>
                            </td>
                        </tr>
<!--
                        <tr>
                            <th><h4 class="title03">추가 특이사항</h4></th>
                            <td colspan="3">
                                <ul class="radio-wrap symptom">
                                    <template v-for="option in extraOption" :key="option">
                                        <li>
                                            <label :for="'extra'+option.value">
                                                <input type="checkbox" v-model="selectedNote.extraOptionTemp" :value="option.value" :id="'extra'+option.value" disabled/>
                                                <span class="radio-btn"></span>
                                                <p>{{ option.label }}</p>
                                            </label>
                                        </li>
                                    </template>
                                </ul>
                            </td>
                        </tr>
                        -->
                        <tr v-if="selectedNote.extraOptionTemp.includes('01') && selectedNote.auraTemp.length > 0">
                            <th><h4 class="title03">두통 전조 증상</h4></th>
                            <td>
                                <ul class="head-symptom__list">
                                    <template v-for="option in aura" :key="option">
                                        <li v-if="selectedNote.auraTemp.includes(option.value)">
                                            <a href="javascript:;">
                                                <div class="icon" :class="`head-${option.value === 'etc' ? 'etc' : 'aura' + option.value}`"></div>
                                                <p>{{ option.label }}</p>
                                            </a>
                                        </li>
                                    </template>
                                </ul>
                                <input v-if="selectedNote.auraTemp.includes('etc')" type="text" class="head-symptom__input" :value="selectedNote.auraEtc" disabled>
                            </td>
                        </tr>
                        <tr v-if="selectedNote.extraOptionTemp.includes('02') && selectedNote.painSymptomTemp.length > 0">
                            <th>
                                <h4 class="title03">두통 중 동반 증상</h4>
                            </th>
                            <td colspan="3">
                                <ul class="head-symptom__list">
                                    <template v-for="option in painSymptom" :key="option">
                                        <li v-if="selectedNote.painSymptomTemp.includes(option.value)">
                                            <a href="javascript:;">
                                                <div class="icon" :class="`head-${option.value === 'etc' ? 'etc' : 'with' + option.value}`"></div>
                                                <p>{{ option.label }}</p>
                                            </a>
                                        </li>
                                    </template>
                                </ul>
                                <input v-if="selectedNote.painSymptomTemp.includes('etc')" type="text" class="head-symptom__input" :value="selectedNote.painSymptomEtc" disabled>
                            </td>
                        </tr>
                        <tr v-if="selectedNote.extraOptionTemp.includes('03') && selectedNote.painCausesTemp.length > 0">
                            <th>
                                <h4 class="title03">두통 유발 요인</h4>
                            </th>
                            <td colspan="3">
                                <ul class="head-symptom__list">
                                    <template v-for="option in painCauses" :key="option">
                                        <li v-if="selectedNote.painCausesTemp.includes(option.value)">
                                            <a href="javascript:;">
                                                <div class="icon" :class="`head-${option.value === 'etc' ? 'etc' : 'factor' + option.value}`"></div>
                                                <p>{{ option.label }}</p>
                                            </a>
                                        </li>
                                    </template>
                                </ul>
                                <input v-if="selectedNote.painCausesTemp.includes('etc')" type="text" class="head-symptom__input" :value="selectedNote.painCausesEtc" disabled>
                            </td>
                        </tr>
                        <tr v-if="selectedNote.extraOptionTemp.includes('04') && selectedNote.reliefActionTemp.length > 0">
                            <th><h4 class="title03">두통 완화 조치</h4></th>
                            <td>
                                <ul class="head-symptom__list">
                                    <template v-for="option in reliefAction" :key="option">
                                        <li v-if="selectedNote.reliefActionTemp.includes(option.value)">
                                            <a href="javascript:;">
                                                <div class="icon" :class="`head-${option.value === 'etc' ? 'etc' : 'mitigation' + option.value}`"></div>
                                                <p>{{ option.label }}</p>
                                            </a>
                                        </li>
                                    </template>
                                </ul>
                                <input v-if="selectedNote.reliefActionTemp.includes('etc')" type="text" class="head-symptom__input" :value="selectedNote.reliefActionEtc" disabled>
                            </td>
                        </tr>
                        <tr>
                            <th><h4 class="title03">기타 메모</h4></th>
                            <td class="left">
                                <input type="text" class="head-symptom__input" :value="selectedNote.etcMemo" disabled>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SampleComponent',
    components: {
    },
    data() {
        return {
            customFormat: 'yyyy-MM-dd',  // 날짜 포맷

            // 캘린더
            classList: '',
            startDate: '',
            endDate: '',
            today: new Date(),
            calendarList: '',
            calYear: '',
            calMonth: '',
            activeIndex: '',

            toDay: this.$commonUtils.getToday(),
            //selectDay에 현재 날짜( yyymmdd형식)으로 초기화
            selectDay: this.$commonUtils.getToday(),
            selectedNote: {},

            noteList: [],
            currentNoteList: [],
            areaOptions: Array.from({ length: 18 }, (_, index) => index + 1),
            extraOption: [
                { label: '두통 전조증상', value: '01' },
                { label: '두통 중 동반증상', value: '02' },
                { label: '두통 유발 요인', value: '03' },
                { label: '두통 완화 조치', value: '04' },
            ],
            painSymptom: [
                { label: '울렁거림', value: '01' },
                { label: '구토', value: '02' },
                { label: '어지럼증', value: '03' },
                { label: '움직임에 의한 악화', value: '04' },
                { label: '시야가 흐릿함', value: '05' },
                { label: '이명', value: '06' },
                { label: '안구통', value: '07' },
                { label: '기타', value: 'etc' }
            ],
            painType: [
                { label:'욱신거림', value: '01' },
                { label:'깨질듯', value: '02' },
                { label:'쥐어짜듯', value: '03' },
                { label:'터질듯함', value: '04' },
                { label:'찌르는듯', value: '05' },
                { label:'기타', value: 'etc' }
            ],
            aura: [
                { label:'아플 것 같은 느낌', value: '01' },
                { label:'어깨 뻐근함', value: '02' },
                { label:'하품', value: '03' },
                { label:'피로', value: '04' },
                { label:'소화장애', value: '05' },
                { label:'빛·소리 민감', value: '06' },
                { label:'기타', value: 'etc' }
            ],
            painCauses: [
                { label:'스트레스', value: '01' },
                { label:'수면부족', value: '02' },
                { label:'늦잠', value: '03' },
                { label:'굶음', value: '04' },
                { label:'냄새', value: '05' },
                { label:'음주', value: '06' },
                { label:'월경', value: '07' },
                { label:'성관계', value: '08' },
                { label:'운동', value: '09' },
                { label:'소화불량', value: '10' },
                { label:'기타', value: 'etc' }
            ],
            reliefAction: [
                { label:'휴식', value: '01' },
                { label:'수면', value: '02' },
                { label:'요가/명상', value: '03' },
                { label:'마사지', value: '04' },
                { label:'약', value: '05' },
                { label:'기타', value: 'etc' }
            ]
        };
    },
    methods: {
        getCheckClass(option) {
            const className = option < 10 ? `check0${option}` : `check${option}`;
            return className;
        },
        todayCalendar(){
            this.today = new Date();
            this.init();
            this.selectDay = this.toDay
            this.selectDate(this.today.getFullYear(), this.$commonUtils.leftPad(this.today.getMonth() + 1), this.$commonUtils.leftPad(this.today.getDate()), true)
        },
        prevCalendar(){
            this.today = new Date(this.today.getFullYear(), this.today.getMonth() - 1, 1);
            this.init();
        },
        nextCalendar(){
            this.today = new Date(this.today.getFullYear(), this.today.getMonth() + 1, 1);
            this.init();
        },
        arrChunk(arr){
            return arr.reduce(function (acc, val, index) {
                const chunkIndex = Math.floor(index / 7);
                if (!acc[chunkIndex]) {
                    acc[chunkIndex] = [];
                }
                acc[chunkIndex].push(val);
                return acc;
            }, []);
        },
        /**
         * 이번 달의 첫 날, 마지막 날 구하기
         */
        async init(){
            this.startDate = new Date(this.today.getFullYear(), this.today.getMonth(), 1);
            this.endDate = new Date(this.today.getFullYear(), this.today.getMonth() + 1, 0);
            this.createCalendar();

            await this.getList();
        },
        /**
         * 달력 생성
         */
        createCalendar(){
            console.log('createCalendar')
            this.activeIndex = ''
            this.calendarList = [];
            this.calYear = this.today.getFullYear();
            this.calMonth = this.$commonUtils.leftPad(this.today.getMonth() + 1);
            console.log('startdate'+this.startDate)

            if(this.startDate.getDay() > 0){
                let preLastSunDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), ((this.startDate.getDay() - 1) * -1));
                let preLastDate = new Date(preLastSunDate.getFullYear(), preLastSunDate.getMonth() + 1, 0);

                // 지난달 구하기
                for (let preDay = preLastSunDate; preDay <= preLastDate; preDay.setDate(preDay.getDate() + 1)) {
                    let date = {
                        year : preDay.getFullYear(),
                        month : this.$commonUtils.leftPad(preDay.getMonth() + 1),
                        day : this.$commonUtils.leftPad(preDay.getDate()),
                        week : preDay.getDay(), // 0~6
                        text : this.$commonUtils.dateToStr(preDay, ''),
                        dayType : 'none'
                    }

                    this.calendarList.push(date);
                }
            }
            console.log('startdate'+this.startDate)

            let today = new Date();
            today.setHours(0, 0, 0, 0); // 시간 초기화

            // 이번달 구하기
            for (let nowDay = this.startDate; nowDay <= this.endDate; nowDay.setDate(nowDay.getDate() + 1)) {
                let date = {
                    year : nowDay.getFullYear(),
                    month : this.$commonUtils.leftPad(nowDay.getMonth() + 1),
                    day : this.$commonUtils.leftPad(nowDay.getDate()),
                    week : nowDay.getDay(),
                    text : this.$commonUtils.dateToStr(nowDay, ''),
                    dayType : ''
                }

                if (nowDay < today) {
                    // date.dayType = "pastDay";
                } else if (nowDay.getFullYear() == today.getFullYear()
                    && nowDay.getMonth() == today.getMonth() && nowDay.getDate() == today.getDate()) {
                    date.dayType = "today";
                }else {
                    // date.dayType = "futureDay";
                }

                this.calendarList.push(date);
            }

            // 다음달 구하기
            if(this.endDate.getDay() < 6){
                let nextFirstDate = new Date(this.endDate.getFullYear(), this.endDate.getMonth() + 1, 1);
                let nextFirstSunDate = new Date(nextFirstDate.getFullYear(), nextFirstDate.getMonth(), ((this.endDate.getDay() - 7 ) * -1) -1);

                for (let nextDay = nextFirstDate; nextDay <= nextFirstSunDate; nextDay.setDate(nextDay.getDate() + 1)) {
                    let date = {
                        year : nextDay.getFullYear(),
                        month : this.$commonUtils.leftPad(nextDay.getMonth() + 1),
                        day : this.$commonUtils.leftPad(nextDay.getDate()),
                        week : nextDay.getDay(),
                        text : this.$commonUtils.dateToStr(nextDay, ''),
                        dayType : 'none'
                    }

                    this.calendarList.push(date);
                }
            }

        },
        selectDate(year, month, day, isInit){
            const date = year + '' + month + '' + day;
            this.tempDay = date;

            document.querySelectorAll('.blood-calendar__body  td').forEach(el => {
                el.classList.remove('active')
            })

            this.selectDay = this.tempDay;
            this.selectedNote = {}

            //noteList의 painDate 가 없으면 작성페이지로 이동
            if(!this.hasNoteDay(date) && !isInit){
                this.$router.push(`/kr/mypage/headNote/headNoteWrite?painDate=${date}`)
            }
            console.log(this.noteList)
            console.log(date)

            this.currentNoteList = this.noteList.filter(item => item.painDate === date)
        },
        async getList(){
            let startDate = '' + this.calYear + this.calMonth + '01'
            let endDate = '' + this.calYear + this.calMonth + '31'

            await this.axios.get(this.api.mypage.headNoteList, {
                params: {
                    startDate: startDate,
                    endDate: endDate,
                }
            })
            .then(response => {
                this.noteList = response.data
            });
        },
        hasNoteDay(date){
            //noteList의 painDate와 같은 날짜가 있는지 확인
            let result = false

            for(let i of this.noteList){
                if(i.painDate == date){
                    result = true
                    break
                }
            }

            return result
        },
        selectNote(item){
            this.selectedNote = item

            this.selectedNote.painAreaTemp = this.selectedNote.painArea ? this.selectedNote.painArea.split(',') : []
            this.selectedNote.auraTemp = this.selectedNote.aura ? this.selectedNote.aura.split(',') : []
            this.selectedNote.painCausesTemp = this.selectedNote.painCauses ? this.selectedNote.painCauses.split(',') : []
            this.selectedNote.reliefActionTemp = this.selectedNote.reliefAction ? this.selectedNote.reliefAction.split(',') : []
            this.selectedNote.painSymptomTemp = this.selectedNote.painSymptom ? this.selectedNote.painSymptom.split(',') : []
            this.selectedNote.extraOptionTemp = this.selectedNote.extraOption ? this.selectedNote.extraOption.split(',') : []

        },
        async deleteNote(){
            if(confirm('삭제하시겠습니까?')){
                await this.axios.post(this.api.mypage.headNoteDelete, null, {
                    params: {
                        brSeq: this.selectedNote.brSeq
                    }
                })
                .then(response => {
                    this.selectedNote = {}


                });
                await this.getList()

                this.selectDate(this.tempDay.slice(0, 4), this.tempDay.slice(4, 6), this.tempDay.slice(6, 8),true)
            }
        },
        modifyNote(){
            this.$router.push(`/kr/mypage/headNote/headNoteWrite?brSeq=${this.selectedNote.brSeq}&painDate=${this.selectedNote.painDate}`)
        }
    },
    async mounted() {
        // 테이블의 .table에 클릭 이벤트를 추가
        const tables = document.querySelectorAll('.table');

        tables.forEach((table) => {
            // .table 요소의 가상 요소 부분을 클릭한 것처럼 처리할 수 있게,
            // 테이블의 `::before`가 클릭될 수 있는 영역을 감싸는 영역을 클릭 이벤트로 처리
            table.addEventListener('click', () => {
                // 테이블에 'active' 클래스를 토글
                table.classList.add('active');
            });
        });

        // #app 요소에 brain 클래스 추가
        const appElement = document.getElementById('app');
        if (appElement) {
            appElement.classList.add('brain');
        }
        await this.init();

        //현재 날짜 선택(yyyy, mm, dd) 01, 02 형식
        this.selectDate(this.today.getFullYear(), this.$commonUtils.leftPad(this.today.getMonth() + 1), this.$commonUtils.leftPad(this.today.getDate()), true)
    },

}
</script>

<style scoped></style>